import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../services';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const user = this.authService.userValue;
        const isApiUrl = request.url.startsWith(environment.appApi);
        const isServiceUrl = request.url.startsWith(environment.messageServiceUrl);
        const authUrl = request.url.startsWith(environment.appApi + '/oauth/token');
        const registerUrl = request.url.startsWith(environment.appApi + '/registration');
        const eventmobi = request.url.startsWith(environment.appApi + '/eventmobi');


        if (user && (isApiUrl || isServiceUrl) && !authUrl && !registerUrl && !eventmobi) {
            // Token-Timestamp prüfen
            const storedData = localStorage.getItem('currentUser');
            if (storedData) {
                try {
                    const parsed = JSON.parse(storedData);
                    if (parsed.timestamp && parsed.timestamp + 3600000 < Date.now()) {
                        // Token abgelaufen - Cleanup und Redirect
                        localStorage.removeItem('currentUser');
                        localStorage.removeItem('currentUserData');
                        this.router.navigate(['/login']);
                        return throwError(() => new Error('Token expired'));
                    }
                } catch {
                    // Fehlerhafte Daten
                    this.router.navigate(['/login']);
                    return throwError(() => new Error('Invalid token data'));
                }
            }

            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + user.access_token
                }
            });
        }

        return next.handle(request);
    }
}
